<template>
    <div id="user-management">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Tryout Members',
                    to: { path: '/tryout-members' },
                    exact: true,
                },
                { text: 'Daftar Tryout' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Daftar Tryout</h3>

        <v-card>
            <app-datatable
                :items="resultQuery"
                :headers="headers"
                :has-custom-pagination="true"
                :custom-pagination-current-page="pageNumber"
                v-on:dblClicked="goToDetail"
                v-on:changePage="pageNumber = $event"
                v-on:doSearch="
                    query = $event;
                    loadUserData();
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import axios from "axios";
import DataTable from "@/modules/global/components/plugins/DataTable-s";

export default {
    name: "user-management",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            query: null,
            isLoading: false,
            pageNumber: 1,
            tryouts: [],
            headers: [
                { text: "No.", value: "no" },
                { text: "Nama Tryout", value: "name" },
            ],
        };
    },

    computed: {
        resultQuery() {
            if (this.query) {
                return this.tryouts.filter((item) => {
                    return this.query
                        .toLowerCase()
                        .split(" ")
                        .every((v) => item.name.toLowerCase().includes(v));
                });
            }
            return this.tryouts;
        },
    },

    watch: {
        pageNumber: function (newVal) {
            this.loadUserData(newVal);
        },
    },

    methods: {
        loadUserData: function (pageNumber = 1) {
            var context = this;
            var token = this.$ls.get("token");
            var url =
                process.env.API_BASE_URL +
                "tryout-service/tryout_group/" +
                this.$route.params.id;

            this.isLoading = true;
            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url, {
                params: {
                    page: pageNumber,
                    search_by: "name",
                    search: this.query,
                },
            })
                .then(function (response) {
                    context.tryouts = response.data.tryouts;
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        goToDetail: function (index) {
            const rawData = this.tryouts[index];
            var data = rawData;
            this.$store.commit("tryout_init", data);
            this.$router.push(
                "/tryout-members-detail/" +
                    this.$route.params.id +
                    "/" +
                    this.tryouts[index].id,
            );
        },
    },

    mounted: function () {
        this.loadUserData();
    },
};
</script>



// WEBPACK FOOTER //
// TryoutMembersList.vue?5063ba7c